const actionTypes = {
    GIFT_CARD_APPLIED: 'GIFT_CARD_APPLIED',
    ORDER_ERRORS: 'ORDER_ERRORS',
    ORDER_REVIEW_TOGGLE: 'ORDER_REVIEW_TOGGLE',
    PAYMENT_CARD_NUMBER_CHANGED: 'PAYMENT_CARD_NUMBER_CHANGED',
    PAYMENT_CARDS_DETECTED: 'PAYMENT_CARDS_DETECTED',
    SECTION_SAVED: 'SECTION_SAVED',
    SET_PLACE_ORDER_PRE_HOOK: 'SET_PLACE_ORDER_PRE_HOOK',
    SUBMITTED_ORDER: 'SUBMITTED_ORDER',
    TOGGLE_CVC_INFO_MODAL: 'TOGGLE_CVC_INFO_MODAL',
    TOGGLE_PLACE_ORDER: 'TOGGLE_PLACE_ORDER',
    UPDATE_DELIVERY_INSTRUCTIONS: 'UPDATE_DELIVERY_INSTRUCTIONS',
    UPDATE_ORDER_GIFT_WRAP_OPTIONS: 'UPDATE_ORDER_GIFT_WRAP_OPTIONS',
    UPDATE_ORDER: 'UPDATE_ORDER',
    UPDATE_SHIPPING_METHODS: 'UPDATE_SHIPPING_METHODS',
    VALIDATE_ADDRESS: 'VALIDATE_ADDRESS',
    CREATE_DRAFT_HAL_ADDRESS: 'CREATE_DRAFT_HAL_ADDRESS',
    REMOVE_HAL_ADDRESS: 'REMOVE_HAL_ADDRESS',
    SHOW_SCHEDULED_DELIVERY_UNAVAILABLE: 'SHOW_SCHEDULED_DELIVERY_UNAVAILABLE',
    UPDATE_CURRENT_HAL_ADDRESS: 'UPDATE_CURRENT_HAL_ADDRESS',
    UPDATE_ADDRESS_LIST_WITH_HAL_ADDRESS: 'UPDATE_ADDRESS_LIST_WITH_HAL_ADDRESS',
    UPDATE_SEPHORA_TERMS: 'UPDATE_SEPHORA_TERMS',
    UPDATE_AUTOREPLENISH_TERMS: 'UPDATE_AUTOREPLENISH_TERMS',
    UPDATE_SDU_TERMS: 'UPDATE_SDU_TERMS',
    SET_DELIVERY_ISSUES: 'SET_DELIVERY_ISSUES',
    SET_SELECTED_DELIVERY_ISSUE: 'SET_SELECTED_DELIVERY_ISSUE',
    SET_DELIVERY_ISSUE_MODAL_SCREEN: 'SET_DELIVERY_ISSUE_MODAL_SCREEN',
    SET_RETURN_ELIGIBILITY: 'SET_RETURN_ELIGIBILITY',
    SET_DELIVERY_ISSUE_ERROR: 'SET_DELIVERY_ISSUE_ERROR',
    SET_LAST_SHIPPING_ADDRESS_ID: 'SET_LAST_SHIPPING_ADDRESS_ID'
};

module.exports = actionTypes;
